import React, { FC, Fragment } from 'react';
import Card from 'src/components/Card';
import BossNote from '../../../interfaces/api/BossNote';
import { Grid, Typography } from '@material-ui/core';
import { createUseStyles } from '../../../theming';
import clsx from 'clsx';

interface Props {
  bossNotes: BossNote[];
}

const useStyles = createUseStyles({
  root: {},
  title: {
    color: 'inherit',
  },
  'alert-success': {
    backgroundColor: '#c8facd !important',
    boxShadow: 'none !important',
    color: '#005249 !important',
  },
  'alert-danger': {
    backgroundColor: '#ffe7d9 !important',
    boxShadow: 'none !important',
    color: '#7a0c2e !important',
  },
  'alert-info': {
    backgroundColor: '#d0f2ff !important',
    boxShadow: 'none !important',
    color: '#04297a !important',
  },
  'alert-warning': {
    backgroundColor: '#fff7cd !important',
    boxShadow: 'none !important',
    color: '#7a4f01 !important',
  },
});

const PanelBossNote: FC<Props> = ({ bossNotes }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {bossNotes
        .sort((a, b) => a.position - b.position)
        .map((bossNote, key) => (
          <Grid item xs={12} md={bossNote.width || 4} key={key}>
            <Card className={clsx({ [classes[`alert-${bossNote.color || 'success'}`]]: bossNote.type === 'alert' })}>
              <Typography variant='h6' className={classes.title} gutterBottom>
                {bossNote.title}
              </Typography>

              <p>
                {bossNote.text.split('\n').map((line, key) => (
                  <Fragment key={key}>
                    {line}
                    <br />
                  </Fragment>
                ))}
              </p>
            </Card>
          </Grid>
        ))}
    </Grid>
  );
};

export default PanelBossNote;
